import type { LiveStreamPreferences } from './types/index';

const LIVE_STREAM_PREFERENCES_FIELD = 'liveStreamPreferences';

export function setPreferencesStorage(
  value: Partial<LiveStreamPreferences>,
): void {
  localStorage.setItem(LIVE_STREAM_PREFERENCES_FIELD, JSON.stringify(value));
}

export function getPreferencesStorage(): LiveStreamPreferences | null {
  const preferences = localStorage.getItem(LIVE_STREAM_PREFERENCES_FIELD);

  return preferences && JSON.parse(preferences);
}

export function clearPreferencesStorage(): void {
  localStorage.removeItem(LIVE_STREAM_PREFERENCES_FIELD);
}
